<form #fReplaceDoc="ngForm" (ngSubmit)="onOk()">
    <div class="title" fxLayout="row" fxLayoutAlign="start">
      <span mat-dialog-title role="heading" aria-level="1">Choose existing document as primary</span>
    </div>
    <mat-dialog-content fxLayoutAlign="center" fxLayout="column">
        <mat-form-field appearance="outline" floatLabel="always" style="width: 100%">
            <mat-select name="replaceDoc" ngModel [(ngModel)]="selectedDocument" placeholder="Please Select">
              <mat-option *ngFor="let value of data.associatedDocuments" [value]="value">
                {{value.fileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
      <button mat-raised-button type="button" color="warn" (click)="onCancel()">Cancel</button>
      <button mat-raised-button type="submit" color="primary" [disabled]="fReplaceDoc.invalid || !fReplaceDoc.dirty || isLoading">Submit</button>
    </mat-dialog-actions>
  </form>
